/**
 * useDismissible
 *
 * Provides persistent dismiss state for homepage suggestion cards.
 *
 * Backed by the homepage_state JSONB endpoint — `dismissedCards` key.
 */
import { useCallback } from "react";
import {
  getDismissedCards,
  useHomepageState,
  useMergeHomepageState,
} from "@src/packages/patients/hooks/useHomepageState";

export function useDismissible(cardKey: string) {
  const { data: state, isLoading } = useHomepageState();
  const dismissedCards = getDismissedCards(state);
  const { mutate: mergeHomepage } = useMergeHomepageState();

  const isDismissed = !!dismissedCards[cardKey];

  const dismiss = useCallback(() => {
    mergeHomepage({ dismissedCards: { ...dismissedCards, [cardKey]: true } });
  }, [cardKey, dismissedCards, mergeHomepage]);

  const restore = useCallback(() => {
    mergeHomepage({ dismissedCards: { ...dismissedCards, [cardKey]: false } });
  }, [cardKey, dismissedCards, mergeHomepage]);

  return { isDismissed, dismiss, restore, isLoading };
}
